import * as PIXI from 'pixi.js';

export class Guide extends PIXI.Container {
    constructor(no: number, onLoad?: () => void) {
        super();

        const no2 = no === undefined ? 1 : (no + 1);
        const id = 'guide' + no2;

        const a = PIXI.utils.TextureCache[id];
        if (a) {
            const s = PIXI.Sprite.from(a);
            this.addChild(s);
            setTimeout(() => {
                if (onLoad) onLoad();
            }, 0);
        } else {
            const l = new PIXI.Loader();
            l.add(id, `img/common__face-guide-${no2}.jpg`);
            l.load((loader, resources) => {
                const s = PIXI.Sprite.from(resources[id]!.texture);
                this.addChild(s);
                if (onLoad) onLoad();
            });
        }
    }
}